function ZentrySvg() {
  return (
    <svg
      width={148}
      height={39}
      viewBox="0 0 148 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_228_11306)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M47.4745 28.3652L47.6922 25.1904L56.5707 14.3814H47.9466L47.2713 10.4746H62.4775L62.2598 13.6439L53.8936 24.4584H62.4336L62.4135 28.3652H47.4745ZM65.0229 28.3652V10.4746H78.8036L77.7405 14.1984H68.9425V17.5544H77.4934V21.2781H68.9425V24.6433H77.8191L78.3059 28.367H65.0211L65.0229 28.3652ZM95.8287 28.3652V10.4746H91.4864V20.6706L84.4872 10.4746H80.8768V28.3652H85.1038V18.1912L92.136 28.3652H95.8269H95.8287ZM98.5662 14.1984V10.4746H113.997L112.934 14.1984H109.13H105.165L108.393 15.9917V28.367H104.074V14.1984H98.5643H98.5662ZM116.18 10.4746V28.3652H119.992V22.2827H122.786L125.147 26.7019L125.15 26.7092L125.992 28.367H130.523L128.27 24.1876L128.267 24.1803L126.903 21.5197C127.82 21.0604 128.538 20.4126 129.041 19.5764C129.571 18.687 129.829 17.6404 129.829 16.4473C129.829 15.2542 129.575 14.2094 129.052 13.3072C128.534 12.3978 127.776 11.6988 126.796 11.2102C125.817 10.7143 124.653 10.4764 123.313 10.4764H116.179L116.18 10.4746ZM123.408 18.6358H119.855L119.807 16.1472V14.1728H123.39C123.721 14.1728 123.946 14.1966 124.137 14.2405C124.327 14.2844 124.495 14.3503 124.717 14.4491H124.719L124.72 14.4509C125.121 14.6247 125.399 14.8699 125.579 15.1847V15.1883C125.767 15.5104 125.871 15.924 125.871 16.4436C125.871 16.9633 125.767 17.3622 125.58 17.6715V17.6751C125.403 17.9771 125.129 18.2131 124.733 18.3778C124.314 18.5516 124.043 18.634 123.405 18.634L123.408 18.6358ZM130.627 10.4746H135.539L139.315 17.6056L143.089 10.4746H148L141.48 22.0302V28.3652H137.145V22.0302L130.627 10.4746Z"
          fill="#fff"
        />
      </g>
      <g clipPath="url(#clip1_228_11306)">
        <path
          d="M19.7369 12.9321H0.207245L35.7799 0.621826L21.5985 22.6511L19.736 12.9312L19.7369 12.9321Z"
          fill="#fff"
        />
        <path
          d="M18.7239 26.0679H38.2536L2.68002 38.3783L16.8614 16.349L18.7239 26.0689V26.0679Z"
          fill="#fff"
        />
      </g>
      <defs>
        <clipPath id="clip0_228_11306">
          <rect
            width="100.729"
            height="17.8906"
            fill="white"
            transform="translate(47.2713 10.4746)"
          />
        </clipPath>
        <clipPath id="clip1_228_11306">
          <rect
            width="38.0464"
            height="37.7565"
            fill="white"
            transform="translate(0.207245 0.621826)"
          />
        </clipPath>
      </defs>
    </svg>

  );
}

export default ZentrySvg;